export function log(...params) {
  if (window.location.hostname === 'localhost')
    console.log(...params)
}



/** WEBPACK FOOTER **
 ** ./src/scripts/utils/log.js
 **/